import { render, staticRenderFns } from "./ClassReport.vue?vue&type=template&id=194677c0"
import script from "./ClassReport.vue?vue&type=script&lang=js"
export * from "./ClassReport.vue?vue&type=script&lang=js"
import style0 from "./ClassReport.vue?vue&type=style&index=0&id=194677c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports